import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  captureDatosMaestrosReturnContext,
  isDatosMaestrosNavigationActive,
} from "@/modules/datosMaestros/datosMaestrosNavigation";

/** Persiste y expone si la pantalla actual se abrió desde Datos Maestros. */
export function useDatosMaestrosNavigationContext() {
  const location = useLocation();
  const active = isDatosMaestrosNavigationActive(location);

  useEffect(() => {
    if (active) {
      captureDatosMaestrosReturnContext(location);
    }
  }, [active, location.pathname, location.search, location.state]);

  return { active };
}
